import React, { useMemo } from 'react';
import P from '@splunk/react-ui/Paragraph';
import {
    confirmationText,
    modalBodyText,
    DEFAULT_ITEM_TYPE,
} from './constants';
import { formatUsageConjunction } from './formatUsageConjunction';
import type { ConfirmDeletionModalProps, UsageInfo } from './types';

const emptyUsageArray = [] as UsageInfo[];

export const ConfirmDeletionBody = ({
    itemName,
    itemType = DEFAULT_ITEM_TYPE,
    itemUsage = emptyUsageArray,
}: Pick<ConfirmDeletionModalProps, 'itemName' | 'itemType' | 'itemUsage'>) => {
    const confirmation = useMemo(
        () => <P>{confirmationText(itemType)}</P>,
        [itemType]
    );

    const enumeratedUsage = useMemo(() => {
        if (!itemName) {
            return null;
        }

        const usageConjunction = formatUsageConjunction(itemUsage);
        if (usageConjunction === null) {
            return null;
        }

        return <P>{modalBodyText({ itemName, usageConjunction })}</P>;
    }, [itemName, itemUsage]);

    return (
        <>
            {enumeratedUsage}
            {confirmation}
        </>
    );
};
